/* eslint-disable no-warning-comments */
/* eslint-disable no-eval */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { HmacSHA256, enc } from 'crypto-js';
import { TokenScheme, FormConfigType, TokenexInitConfigType } from '@cloudbeds/payment-tokenization';

// TODO: MOVE TO ENV!!!
const REACT_APP_MODE = 'test';
const TOKENEX_ID_PCI_TEST = '5038537469456515';
const TOKENEX_SECRET_PCI_TEST = '4YT3ApVjykAkZ9SEgYREM3nEDzhWpDMCjvhpc9Ym';

const TOKENEX_ID_PCI_PROD = '7377181894029084';
const TOKENEX_SECRET_PCI_PROD = 'JOVRyVCaiGEE8IqKfWxAgWyAtyOQvP6KIfzDiQQ5';

const mockDelay = (ms = 1000) => new Promise(r => { setTimeout(r, ms); });

export const generateTokenexInitConfigurationMock = (): TokenexInitConfigType => {
  const origin = `${window.location.protocol}//${window.location.host}`;

  const env = REACT_APP_MODE || 'test';
  const tokenScheme = TokenScheme.Card;
  const tokenExID = eval(`TOKENEX_ID_PCI_${env.toUpperCase()}`);
  const clientSecretKey = eval(`TOKENEX_SECRET_PCI_${env.toUpperCase()}`);
  const timestamp = new Date()
    .toISOString().replace(/[^0-9]/g, '').slice(0, -3); // @ outputs UTC date in yyyyMMddHHmmss

  const authenticationKey = (() => {
    const concatenatedData = `${tokenExID}|${origin}|${timestamp}|${tokenScheme}`;
    const hmac = HmacSHA256(concatenatedData, clientSecretKey);
    const hmacAsBase64 = enc.Base64.stringify(hmac);
    return hmacAsBase64;
  })();

  return {
    origin,
    timestamp,
    tokenExID,
    tokenScheme,
    authenticationKey,
  };
};

export const generateFormConfigMock = (): Partial<FormConfigType> => ({
  cardFields: {
    cardholderName: {
      required: true,
    },
    cardNumber: {
      required: true,
    },
    expiry: {
      required: true,
    },
    cvv: {
      required: true,
    },
  },
  contactFields: {
    firstName: {
      required: true,
    },
    lastName: {
      required: true,
    },
  },
  billingFields: {
    // billingAddress: {
    //   required: false,
    // },
    // billingCountry: {
    //   required: true,
    // },
    // billingEmail: {
    //   required: false,
    // },
  },
});
